module.exports = __webpack_public_path__ + "static/media/mo.034cfe67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mo.png
// module id = 1926
// module chunks = 0